import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.8 5.297A1.51 1.51 0 0 0 21 3.825V1.5A1.5 1.5 0 0 0 19.5 0h-18A1.5 1.5 0 0 0 0 1.5v2.325a1.51 1.51 0 0 0 1.2 1.472 2.25 2.25 0 0 1 0 4.406A1.51 1.51 0 0 0 0 11.175V13.5A1.5 1.5 0 0 0 1.5 15h18a1.5 1.5 0 0 0 1.5-1.5v-2.325a1.51 1.51 0 0 0-1.2-1.472 2.25 2.25 0 0 1 0-4.406M1.5 11.175a3.75 3.75 0 0 0 0-7.35V1.5h5.25v12H1.5zm18 2.325v-2.325a3.75 3.75 0 0 1 0-7.35V1.5H8.25v12z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }